import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import {
  discountValidate,
  decimalValidate,
  decimalQtyValidate,
  dateConversion,decimalValueValidate
} from "../../../components/Validation";

const TaxForm = (props) => {
  const frmRef = useRef({});
  const { sendRequest: postAddTax } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    const data = {
      taxName: frmRef.current.taxName.value.trim(),
      taxPercentage: frmRef.current.taxPercentage.value.trim(),
      Status: 1,
      orgId: localStorage.getItem("orgId"),
      serviceId: props.sId, 
    };

    postAddTax(
      {
        url: "/api/tax/",
        // method: props.data ? "PUT" : "POST",
        method: "POST",
        body: data,
      },
      (data) => {
        toast.success("Tax Added Successfully");
        props.addForm(false);
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Tax Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Tax Name</label>

                        <input
                          type={"text"}
                          id={"taxName"}
                          
                          required
                          ref={(el) => (frmRef.current["taxName"] = el)}
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Tax Percentage </label>
                        <input
                          type={"text"}
                          id={"taxPercentage"}
                          onKeyUp={(e) => {
                             
                            decimalValueValidate(e);
                          }}
                          
                          required
                          ref={(el) => (frmRef.current["taxPercentage"] = el)}
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row text-center">
                    <div className="col-md-12">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default TaxForm;
